<template>
  <div>
    <div class="tab-box">
      <el-radio-group v-model="activeTab" size="small" @change="refresh">
        <el-radio-button label="list">检测列表</el-radio-button>
        <el-radio-button label="task">任务列表</el-radio-button>
      </el-radio-group>
    </div>
    <div v-if="activeTab=='list'">
      <div style="margin-bottom: 15px;">
        <el-form ref="searchListForm" :model="searchParamsList" inline size="small">
          <el-form-item label="分组">
            <el-select v-model="searchParamsList.group_id" class="w_120" filterable clearable placeholder="全部"
                       @change="handleGroupSearch">
              <el-option v-for="group in groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="子分组">
            <el-select v-model="searchParamsList.child_group_id" class="w_120" filterable clearable placeholder="全部"
                       @change="handleSearch">
              <el-option v-for="group in child_groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="sku替换状态">
            <el-select v-model="searchParamsList.sku_status" class="w_135" clearable placeholder="全部"
                       @change="handleSearch">
              <el-option v-for="item in Object.keys(skuStatus)" :key="item" :label="skuStatus[item].label"
                         :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="检测状态">
            <el-select v-model="searchParamsList.image_check_status" class="w_135" clearable placeholder="全部"
                       @change="handleSearch">
              <el-option v-for="item in Object.keys(statusObj)" :key="item" :label="statusObj[item].label"
                         :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="AI检测状态">
            <el-select v-model="searchParamsList.ai_image_check_status" class="w_135" clearable placeholder="全部"
                       @change="handleSearch">
              <el-option v-for="item in Object.keys(statusObj)" :key="item" :label="statusObj[item].label"
                         :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="鉴图状态">
            <el-select v-model="searchParamsList.appraisal_status" class="w_135" clearable placeholder="全部"
                       @change="handleSearch">
              <el-option v-for="item in Object.keys(appraisal_status)" :key="item" :label="appraisal_status[item].label"
                         :value="appraisal_status[item].value"></el-option>
            </el-select>
          </el-form-item>
          <!--         <el-form-item>
                     <el-button size="small" type="primary" @click="handleSearch">查询</el-button>
                     <el-button size="small" @click="refresh">重置</el-button>
                   </el-form-item>-->
        </el-form>
        <span style="font-size: 14px;margin-right: 20px;">已选&nbsp;<span
            style="color: red;">{{ checkedList.length }}</span>&nbsp;件商品</span>
<!--        <el-button size="small" type="success" @click="handleBatch('batch')">文字检测</el-button>-->
        <el-button plain size="small" type="warning" @click="handleBatch('ai')">AI检测</el-button>
        <el-button plain size="small" type="danger" @click="handleBatch('false')">虚假检测</el-button>
      </div>
      <el-table :key="random+1" ref="listTable" v-loading="loading" :data="tableData"
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                max-height="650px" row-key="item_id" style="width:calc(100% - 15px);"
                @select="changeSelSingle" @select-all="changeSelAll">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column align="center" label="序号" type="index" width="60"></el-table-column>
        <el-table-column align="center" label="商品信息" prop="status">
          <template #default="{ row }">
            <div class="goods-info">
              <el-image :preview-src-list="[row.main_image]" :src="row.main_image" class="goods-img"></el-image>
              <div class="flex-1">
                <div>{{ row.title }}</div>
                <div>{{ row.source_product_id }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="分组" prop="group_name" width="100"></el-table-column> -->
          <el-table-column align="center" label="分组|子分组" prop="channel" show-overflow-tooltip width="200px">
            <template #default="{ row }">
                <!-- <div >{{row.group_id?groupObj[row.group_id]:'' }}</div> -->
                {{ formatGroupName(row) }}
            </template>
          </el-table-column>
        <el-table-column align="center" label="sku替换" prop="status" width="80">
          <template #default="{ row }">
            <el-tag :type="skuStatus[row.sku_status].type" size="small">
              {{ skuStatus[row.sku_status].label }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="检测结果" prop="status" width="80">
          <template #default="{ row }">
            <el-tag :type="statusObj[row.image_check_status].type" size="small">
              {{ statusObj[row.image_check_status].label }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="AI检测结果" prop="status" width="100">
          <template #default="{ row }">
            <el-tag :type="statusObj[row.ai_image_check_status].type" size="small">
              {{ statusObj[row.ai_image_check_status].label }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" prop="status" width="100">
          <template #default="{ row }">
            <el-button size="mini" type="primary" @click="handleDetail(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else>
      <el-form v-if="filterConfig.status_filter" ref="searchTaskForm" :model="searchParamsTask" inline size="small">
        <el-form-item label="状态">
          <el-select v-model="searchParamsTask.status" class="w_120" clearable placeholder="全部"
                     @change="handleSearch">
            <el-option v-for="item in Object.keys(filterConfig.status_filter)" :key="item"
                       :label="filterConfig.status_filter[item]"
                       :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <el-table :key="random+2" ref="taskTable" v-loading="loading" :data="taskList"
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }" max-height="650px"
                style="width:calc(100% - 15px);">
        <el-table-column align="center" label="任务编号" min-width="150" prop="task_no">
          <template #default="{ row }">
            <div> {{ row.task_no }}</div>
            <div style="color: red;font-size: 12px;">扣除算力：{{ row.total_power_num }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="商品分组" prop="channel" show-overflow-tooltip width="200px">
            <template #default="{ row }">
            <!-- <div >{{row.group_id?groupObj[row.group_id]:'' }}</div> -->
                {{ getGroupNameText(row.group_id, row.child_group_id) }}
            </template>
        </el-table-column>
        <el-table-column align="center" label="渠道" prop="channel">
          <template #default="{ row }">
            <div> {{ filterConfig.channel_filter[row.channel] }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="检测范围" prop="detection_scope">
          <template #default="{ row }">
            <div> {{ filterConfig.detection_scope_filter[row.detection_scope] }}</div>
            <div v-if="row.detection_scope==2" class="detection-scope">
<!--              <div>首图：{{ filterConfig.cover_filter[row.include_cover] }}</div>-->
              <div>主图：{{ filterConfig.main_filter[row.include_main] }}</div>
              <div>详情图：{{ filterConfig.detail_filter[row.include_detail] }}</div>
              <div>Sku图 ：{{ filterConfig.sku_filter[row.include_sku] }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="检测类型" prop="detection_type">
          <template #default="{ row }">
            <div> {{ filterConfig.detection_type_filter[row.detection_type] }}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="检测词库" prop="word_depot">
          <template #default="{ row }">
            <el-tag v-for="(item,index) in JSON.parse(row.word_depot)" :key="index" class="mini-tag" size="mini"
                    type="warning">
              {{ filterConfig.word_depot_filter[item] }}
            </el-tag>
          </template>
        </el-table-column> -->
        <!--        <el-table-column align="center" label="数量" prop="normal_count" width="80">
                  <template #default="{ row }">
                    <div style="color: #0e9f1f">正常:{{row.normal_count}}</div>
                    <div style="color: red">异常:{{row.abnormal_count}}</div>
                  </template>
                </el-table-column>-->
        <el-table-column align="center" label="商品数量" prop="product_num"></el-table-column>
        <el-table-column align="center" label="进度" prop="status">
          <template #default="{ row }">
           <div>待检测：{{row.waiting_num||0}}</div>
           <div>检测中：{{row.processing_num||0}}</div>
           <div>已完成：{{row.complete_num||0}}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态" prop="status">
          <template #default="{ row }">
            <el-tag size="small"> {{ filterConfig.status_filter[row.status] }}</el-tag>
            <div v-if="row.remark" style="color: #ef4242;font-size: 12px;line-height: 17px;">{{ row.remark }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="创建时间" min-width="100" prop="created_at"></el-table-column>
        <el-table-column align="center" label="操作" prop="status" width="150">
          <template #default="{ row }">
            <el-button v-if="row.status==1||row.status==2||row.status==8" size="mini" type="primary" @click="handleStop(row)">终止
            </el-button>
            <el-button v-if="row.status==1||row.status==2" size="mini" type="warning" @click="handlePause(row)">暂停
            </el-button>
            <el-button v-if="row.status==8" size="mini" type="success" @click="handleStart(row)">启动
            </el-button>
<!--            <el-button size="mini" type="success" @click="handleView(row)">查看</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="turn_page">
      <el-pagination :current-page.sync="page_data.page" :page-size.sync="page_data.limit"
                     :page-sizes="[50,500]" :total="page_data.total"
                     layout="sizes,total,prev, pager, next, jumper"
                     next-text="下一页" prev-text="上一页" @current-change="handleCurrentChange"
                     @size-change="handleSizeChange"
      />
    </div>

    <el-dialog :visible.sync="detailShow" title="详情">
      <div class="detail-box">
        <div class="box-head">
          <div class="detail-item">
            <el-image :preview-src-list="[detailInfo.main_image]" :src="detailInfo.main_image"
                      class="goods-img"></el-image>
            <div class="flex-1">
              <!--              <div style="width: 80%">-->
              <div style="font-size: 14px;margin-bottom: 6px;">{{ detailInfo.title }}</div>
              <div>商品ID：{{ detailInfo.source_product_id }}</div>
              <!--              </div>-->
            </div>
            <!--            <div style="width: fit-content;text-align: left">
                          <div>检测时间：2026-02-11</div>
                          <div style="margin-top: 10px;">消耗算力：</div>
                        </div>-->
          </div>
        </div>
        <div class="box-body">
          <div v-for="(item,index) in imgList" :key="index" class="detail-item">
            <el-image :preview-src-list="imgList.map(i=>{return i.origin_url})" :src="item.origin_url"
                      class="goods-img"></el-image>
            <div class="flex-1">
              <div class="detail-label">图片类型：{{ imgType[item.image_type] }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!--批量检测-->
    <el-dialog :close-on-click-modal="false" :title="batchType==='ai'?'AI检测':batchType==='false'?'虚假检测':'文字检测'" :visible.sync="batchShow">
      <el-form ref="batchForm" :model="batchInfo" :rules="batchRules" label-width="100px" size="small">

        <el-form-item v-if="batchType==='ai'||batchType==='false'" label="检测范围：" prop="include">
          <!--            <el-checkbox v-model="imgInclude.include_cover" :false-label="0" :true-label="1">检测首图</el-checkbox>-->
          <el-checkbox v-model="imgInclude.include_main" :false-label="0" :true-label="1">检测主图</el-checkbox>
          <el-checkbox v-model="imgInclude.include_detail" :false-label="0" :true-label="1">检测详情图</el-checkbox>
          <el-checkbox v-model="imgInclude.include_sku" :false-label="0" :true-label="1">检测Sku图</el-checkbox>
        </el-form-item>
        <template v-if="batchType==='batch'">
          <el-form-item label="检测范围：" prop="detection_scope">
            <el-radio-group v-model="batchInfo.detection_scope" @change="changeRadioDetection" @click="changeDetection">
              <el-radio :label="1">全部（更优惠）</el-radio>
              <el-radio :label="2">单图</el-radio>
              <!-- <el-radio :label="99">人工鉴图</el-radio> -->
            </el-radio-group>
            <div v-if="batchInfo.detection_scope==2" class="d-s-c">
              <!--            <el-checkbox v-model="imgInclude.include_cover" :false-label="0" :true-label="1">检测首图</el-checkbox>-->
              <el-checkbox v-model="imgInclude.include_main" :false-label="0" :true-label="1">检测主图</el-checkbox>
              <el-checkbox v-model="imgInclude.include_detail" :false-label="0" :true-label="1">检测详情图</el-checkbox>
              <el-checkbox v-model="imgInclude.include_sku" :false-label="0" :true-label="1">检测Sku图</el-checkbox>
            </div>
          </el-form-item>
          <!--        <el-form-item label="检测类型：" prop="detection_type" v-show="batchInfo.detection_scope!==99">
          <el-radio-group v-model="batchInfo.detection_type">
            <el-radio :label="1">普通检测</el-radio>
            <el-radio :label="2">深度检测</el-radio>
          </el-radio-group>
        </el-form-item>-->
          <el-form-item v-show="batchInfo.detection_scope!==99" label="检测词分类：">

              <!--            <div class="check-box" >
                            <div class="check-box-title" >售假品牌词：</div>
                            <el-checkbox-group v-model="batchInfo.word_depots" class="flex-1">
                              <el-checkbox :label="11">系统预配</el-checkbox>
                              <el-checkbox :label="1">商户自配</el-checkbox>
                            </el-checkbox-group>
                          </div>-->
            <!-- <div>
              <div class="check-box">
                <div class="check-box-title">第三方诱导违规词：</div>
                <el-checkbox-group v-model="batchInfo.word_depots" class="flex-1">
                  <el-checkbox :label="12">系统预配</el-checkbox>
                  <el-checkbox :label="2">商户自配</el-checkbox>
                </el-checkbox-group>
              </div>
            </div> -->
          <!-- <el-select v-model="addInfo.lexicon_type">
            <el-option v-for="item in Object.keys(lexiconType)"  :value="item" :label="lexiconType[item].label" :key="item" ></el-option>
          </el-select> -->
            <el-select v-model="batchInfo.lexicon_type" clearable multiple collapse-tags placeholder="全部">
                <el-option v-for="item in dictionaryWordsList" :value="item.id" :label="item.dictionary_name" :key="item.id">
                    <span style="float: left" >{{ item.dictionary_name }}</span>
                    <span style="float: right; color: #e6a23c; font-size: 13px" v-if="item.merchant_id === 0">系统</span>
                    <span style="float: right; color: #017eff; font-size: 13px" v-else>自配</span>
                </el-option>
            </el-select>
          </el-form-item>
          <!--        <el-form-item label="多页检测：">
                    <div style="line-height: 20px!important;margin-top: 6px;margin-bottom: 10px;">
                      <el-checkbox v-model="batchInfoPage.multi_page" :false-label="0" :true-label="1"></el-checkbox>
                      <span style="color: #ff4400;font-size: 12px;">
                        (含开始页跟结束页，输入1~3，则检测第一页到第三页的数据，且需选择每页数量。如检测中余额不足，则当前批次会被停止。)
                      </span>
                    </div>
                    <div v-if="batchInfoPage.multi_page" class="d-s-c">
                      <el-input-number v-model="batchInfoPage.open_page" :controls="false" :min="1" :precision="0"
                                       label="开始页"></el-input-number>
                      <span>&nbsp;—&nbsp; </span>
                      <el-input-number v-model="batchInfoPage.end_page" :controls="false" :min="1" :precision="0"
                                       label="结束页"></el-input-number>
                      <el-select v-model="batchInfoPage.num_page" placeholder="选择每页数量" style="margin-left: 10px">
                        <el-option label="50" value="50"></el-option>
                        <el-option label="500" value="500"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>-->
          <el-form-item v-show="batchInfo.detection_scope==99" label="未添加数据：" prop="re_duplication">
            <el-switch v-model="batchInfo.re_duplication"></el-switch>
          </el-form-item>
        </template>
        <el-form-item label="商品分组：">
          <el-select v-model="batchInfo.group_ids" clearable multiple collapse-tags placeholder="全部" @change="changeBatchGroupIds">
            <el-option v-for="group in groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品子分组：">
          <el-select v-model="batchInfo.child_group_id" clearable multiple collapse-tags placeholder="全部">
            <el-option v-for="group in batch_child_groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检测方式：" prop="detection_method">
          <el-select v-model="batchInfo.detection_method" placeholder="全部">
            <el-option v-for="item in checkWays" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <p v-if="batchInfo.detection_method===9" style="color: #999999;">已选&nbsp;<strong>{{ checkedList.length }}</strong>&nbsp;条数据
          </p>
        </el-form-item>
      </el-form>
      <div class="txt-c" style="margin-top: 40px;">
        <el-button :loading="batchLoading" type="primary" @click="submitDetection">开始检测</el-button>
        <div v-if="batchInfoPage.multi_page&&batchInfo.detection_scope==2" class="mt-6">预计消耗算力(稍微会有出入，以实际扣点为准):
          单图分页检测暂不支持预测，以实际扣点为准算力
        </div>
        <div v-else class="mt-6">预计消耗算力(稍微会有出入，以实际扣点为准):{{ powerNumTotal }}算力</div>
        <div class="mt-6">
          <span style="margin-right: 10px">当前账号剩余算力：{{ userInfo.power_num }}</span>
          <el-button :loading="userLoading" plain size="mini" @click="getUserInfo(true)">刷新</el-button>
          <el-button plain size="mini" type="success" @click="toRecharge">去充值</el-button>
        </div>
      </div>
    </el-dialog>


  </div>
</template>
<script>
import {mapActions} from "vuex";

export default {
  components: {},
  data() {
    var validateInclude = (rule, value, callback) => {
      const keys = Object.keys(this.imgInclude)
      const flag = keys.some(i => this.imgInclude[i] == 1)
      if (!flag) {
        callback(new Error('请选择检测范围'));
      } else {
        callback();
      }
    };
    return {
      random: Math.random(),
      activeTab: 'list',

      loading: false,
      tableData: [],
      taskList: [],//任务列表
      page_data: {
        limit: 50,
        page: 1,
        total: 0,
      },
      searchParamsList: {
        image_check_status: '',
        group_id: '',
        child_group_id: [],
        sku_status: '',
        appraisal_status: '',
        ai_image_check_status: ''
      },
      searchParamsTask: {status: ''},
      selList: [],//选中的商品对象
      checkedList: [],//选中的商品ID
      statusObj: {
        1: {label: '未检测', type: 'error'},
        2: {label: '已检测', type: 'success'},
      },
      skuStatus: {
        1: {label: '未替换', type: 'info'},
        2: {label: '已替换', type: 'success'},
        3: {label: '找不到', type: 'error'}
      },
      appraisal_status: {
        1: {label: '未检测', value: 1, type: 'selected-tag'},
        2: {label: '待检测', value: 4, type: 'selected-tag'},
        3: {label: '有违规', value: 2, type: 'replaced-tag'},
        4: {label: '无违规', value: 3, type: 'notFond-tag'}
      },
      groupList: [],
      child_groupList: [],
      batch_child_groupList: [],
      batchShow: false,
      batchInfo: {},
      batchType: 'batch',//检测 batch-批量检测、ai-Ai检测
      batchInfoPage: {},//批量检测多页信息
      batchLoading: false,
      batchRules: {
        detection_scope: [{required: true, message: '请选择检测范围', trigger: 'change'}],
        detection_type: [{required: true, message: '请选择检测类型', trigger: 'change'}],
        word_depots: [{required: true, message: '请选择检测词库', trigger: 'change', type: 'array'}],
        detection_method: [{required: true, message: '请选择检测方式', trigger: 'change'}],
        include: [{required: true, validator: validateInclude}]
      },
      powerNum: 0,//单算力值
      powerNumTotal: 0,//总算力值
      checkWays: [{label: "自选数据", value: 9}, {label: '未检测数据', value: 2}, {label: '全部检测', value: 1}],
      imgInclude: {},
      detailShow: false,
      detailInfo: {},
      imgList: [],
      imgType: {
        1: '主图',
        2: '轮播图',
        3: '详情图',
        4: 'sku图'
      },
      filterConfig: {},

      userInfo: {},
      userLoading: false,
      dictionaryWordsList:[],


    }
  },
  created() {
  },
  watch: {
    'batchInfo.detection_scope': {
      handler() {
        this.getPowerNum()
      },
      deep: true
    },
    'batchInfo.detection_type': {
      handler() {
        this.getPowerNum()
      },
      deep: true
    },
    'batchInfo.word_depots': {
      handler() {
        this.getPowerNum()
      },
      deep: true
    },
    imgInclude: {
      handler() {
        console.log('变化')
        this.getPowerNumTotal()
      },
      deep: true
    },

    batchInfoPage: {
      handler() {
        this.getPowerNumTotal()
      },
      deep: true
    },

  },
  methods: {
    ...mapActions({
      getImgDetectionList: 'ucenter/getImgDetectionList',
      getProductImagesList: 'ucenter/getProductImagesList',
      opSubmitImageData: 'ucenter/opSubmitImageData',
      opSubmitImageDataManual: 'ucenter/opSubmitImageDataManual',
      opSubmitBatchDetection: 'ucenter/opSubmitBatchDetection',
      opSubmitAiDetection: 'ucenter/opSubmitAiDetection',
      getImgDetectionTask: 'ucenter/getImgDetectionTask',
      opStopImgDetection: 'ucenter/opStopImgDetection',
      opStartImgDetection: 'ucenter/opStartImgDetection',
      opPauseImgDetection: 'ucenter/opPauseImgDetection',
      opGetPredictSinglePowerNum: 'ucenter/opGetPredictSinglePowerNum',
      getCloudProductGroups: 'ucenter/getCloudProductGroups',
      getUserinfoData: 'login/getUserinfoData',
      opGetDictionaryWords: 'ucenter/opGetDictionaryWords',
    }),
    initData() {
      this.searchParamsList = {
        image_check_status: '',
        group_id: '',
        child_group_id: [],
        sku_status: '',
        appraisal_status: '',
        ai_image_check_status: ''
      }
      this.searchParamsTask = {status: ''}
      this.refresh()
      this.getUserInfo()
      this.getGroupList()
      this.getDictionaryWords()
    },
    getDictionaryWords() {
      this.opGetDictionaryWords({
        data: {'dictionary_type': 2},
        success: (res) => {
          if (res.code == 200) {
            let list = res.data || [];
            list.sort((a, b) => (a.merchant_id === 0 ? -1 : 0));
            this.dictionaryWordsList = list;
          } else {
            this.$message.error(res.message)
          }

        }
      })
    },
    getUserInfo(isLoading) {
      this.userLoading = isLoading
      this.getUserinfoData({
        data: {}, success: (res) => {
          this.userLoading = false
          if (res.code === 200) {
            this.userInfo = res.data
          } else {
            this.$message({message: res.msg, type: 'error',});
          }
        }
      })
    },
    // === 获取列表 ===
    getDataList() {
      if (this.activeTab == 'list') {
        this.getList()
      } else {
        console.log('task')
        this.getTaskList()
      }
    },
    handleSizeChange(val) {
      this.page_data.limit = val
      this.page_data.page = 1
      this.getDataList()
    },
    handleCurrentChange(val) {
      this.page_data.page = val
      this.getDataList()
    },
    handleSearch() {
      this.page_data.page = 1
      this.getDataList()
    },
    handleGroupSearch() {
      this.changeGroupIds([this.searchParamsList.group_id])
      this.handleSearch()
    },
    refresh() {
      this.page_data.page = 1
      this.page_data.total = 0
      if (this.$refs.searchListForm) {
        this.$refs.searchListForm.resetFields()
      }
      if (this.$refs.searchTaskForm) {
        this.$refs.searchTaskForm.resetFields()
      }
      this.tableData = []
      this.taskList = []
      this.checkedList = []
      this.selList = []
      this.getDataList()
      this.random = Math.random()
    },
    getList() {
      try {
        this.loading = true
        let param = {
          page_size: this.page_data.limit,
          page: this.page_data.page,
          ...this.searchParamsList
        }
        this.getImgDetectionList({
          data: param,
          success: (res) => {
            this.loading = false
            if (res.code == 200) {
              this.tableData = res.data.list
              this.page_data.total = res.data.total
              this.$nextTick(() => {
                const rows = this.tableData.filter(item => this.checkedList.includes(item.item_id))
                rows.forEach(row => {
                  this.$refs.listTable.toggleRowSelection(row);
                });
              })
            } else {
              this.$message.error(res.message)
            }
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    getTaskList() {
      this.loading = true
      let param = {
        page_size: this.page_data.limit,
        page: this.page_data.page,
        ...this.searchParamsTask
      }
      this.getImgDetectionTask({
        data: param,
        success: (res) => {
          this.loading = false
          if (res.code == 200) {
            this.taskList = res.data.list
            this.page_data.total = res.data.total
            this.filterConfig = {...res.data}
            delete this.filterConfig.list

          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    // 获取分组列表
    getGroupList() {
      this.getCloudProductGroups({
        data: { with_count: 0 },
        success: (res) => {
          if (res.code === 200) {
            this.groupList = res.data || []
          }
        }
      })
    },

    // === 详情 ===
    handleDetail(row) {
      this.detailInfo = {...row}
      this.detailShow = true
      this.getProductImagesList({
        data: {
          item_id: row.item_id
        },
        success: (res) => {
          if (res.code == 200) {
            this.imgList = res.data
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },

    // === 批量检测、AI检测 ===
    handleBatch(type) {
      this.batchType = type
      this.batchShow = true
      let obj = {
        // detection_scope: 1,//检测范围
        // detection_type: 1,//检测类型
        // word_depots: [],//检测词库
        re_duplication: false,//未添加数据
        group_id: '',//商品分组
        child_group_id: [],//商品分组
        detection_method: this.checkedList.length ? 9 : ''
      }
      if (this.batchType === 'batch') {
        obj.detection_scope = 1 //检测范围
        obj.word_depots = [] //检测词库
      }
      this.batchInfo = obj
      this.imgInclude = {
        include_cover: 0,//检测首图
        include_sku: 0,//检测Sku图
        include_detail: 0,//检测详情图
        include_main: 0,//检测主图
      }
      this.batchInfoPage = {
        multi_page: 0,
        open_page: 1,
        end_page: 1,
        num_page: this.page_data.limit
      }
      this.$nextTick(() => {
        this.$refs.batchForm.clearValidate()
      })
    },

    //获取算力值
    getPowerNum() {
      return false
      this.powerNum = 0
      if (this.batchType === 'batch' && !this.batchInfo.word_depots.length) return
      let params = {
        detection_scope: this.batchInfo.detection_scope,
        detection_type: this.batchInfo.detection_type,
        word_depots: this.batchInfo.word_depots.join(',')
      }
      this.opGetPredictSinglePowerNum({
        data: params,
        success: (res) => {
          if (res.code == 200) {
            this.powerNum = res.data
            this.getPowerNumTotal()
          }
        }
      })
    },
    //计算总算力值
    getPowerNumTotal() {
      return false
      if (!this.powerNum) return;
      this.powerNumTotal = 0
      if (this.batchInfoPage.multi_page) {
        if (this.batchInfo.detection_scope == 1) {
          this.powerNumTotal = (this.powerNum * this.batchInfoPage.num_page * (this.batchInfoPage.end_page - this.batchInfoPage.open_page + 1) * 1000) / 1000
        }
      } else {
        if (this.selList.length) {
          if (this.batchInfo.detection_scope == 1) {
            this.powerNumTotal = (this.powerNum * this.selList.length * 1000) / 1000
          } else {
            let imgKey = [{key: 'include_cover', num: 'cover_num'}, {
              key: 'include_main',
              num: 'main_num'
            }, {key: 'include_detail', num: 'detail_num'}, {key: 'include_sku', num: 'sku_num'}]
            let selImgKey = imgKey.filter(item => this.batchInfo[item.key] == 1).map(item => item.num)

            if (!selImgKey.length) return
            let arrays = this.selList.map(item => {
              let arr = selImgKey.map(key => item[key])
              return arr
            })
            let list = arrays[0].map((_, i) => arrays.reduce((acc, arr) => Number(acc) + Number(arr[i]), 0));
            let imgNum = list.reduce((a, b) => Number(a) + Number(b))
            this.powerNumTotal = (this.powerNum * imgNum * 1000) / 1000
          }
        }
      }
    },

    changeSelSingle(val, row) {
      const index = this.checkedList.indexOf(row.item_id)
      if (index >= 0) {
        this.selList = this.selList.filter(i => i.item_id != row.item_id)
        this.checkedList = this.checkedList.filter(i => i != row.item_id)
      } else {
        this.selList.push(row)
        this.checkedList.push(row.item_id)
      }
    },
    changeSelAll(val) {
      const arr = val.map(i => {
        // return i.item_id
        return i
      })
      const allArr = this.tableData.map(i => {
        return i.item_id
      })
      // this.checkedList = val&&val.length ? [...new Set([...this.checkedList, ...arr])] : this.checkedList.filter(i => !allArr.includes(i));
      this.selList = val && val.length ? [...new Set([...this.selList, ...arr])] : this.selList.filter(i => !allArr.includes(i.item_id));
      this.checkedList = this.selList.map(i => {
        return i.item_id
      })

    },
    changeDetection() {
      const keys = ['include_cover', 'include_main', 'include_detail', 'include_sku']
      keys.forEach(key => {
        this.batchInfo[key] = 0
      })
    },
    changeRadioDetection(label) {
      this.batchInfo.detection_sopce = label
      if (label === 99) {
        this.powerNumTotal = 0
      }
    },
    /*submitBatch() {
      const params = {
        ids: this.checkedList.join(',') || '',
        ...this.batchInfo,
        ...this.batchInfoPage
      }

      if (this.batchInfo.detection_sopce === 99) {
        if (!this.batchInfoPage.multi_page && !this.checkedList.length) {
          this.$message.error('请选择要检测的数据')
          return false
        }
        this.opSubmitImageDataManual({
          data: params,
          success: (res) => {
            if (res.code == 200) {
              this.$message.success('操作成功')
              this.batchShow = false
              this.checkedList = []
              this.$refs.listTable.clearSelection();
              this.refresh()
            } else {
              this.$message.error(res.message)
            }
            this.batchLoading = false
          }
        })
      } else {
        this.$refs.batchForm.validate(valid => {
          if (valid) {
            if (!this.batchInfoPage.multi_page && !this.checkedList.length) {
              this.$message.error('请选择要检测的数据')
              return false
            }
            if (this.batchInfoPage.multi_page && this.batchInfo.detection_scope == 2) {

            } else if (this.powerNumTotal > this.userInfo.power_num) {
              this.$message.error('当前剩余算力不足，请充值')
              return false
            }
            params.word_depots = params.word_depots.join(',')
            this.batchLoading = true
            this.opSubmitImageData({
              data: params,
              success: (res) => {
                if (res.code == 200) {
                  this.$message.success('操作成功')
                  this.batchShow = false
                  this.checkedList = []
                  this.$refs.listTable.clearSelection();
                  this.refresh()
                } else {
                  this.$message.error(res.message)
                }
                this.batchLoading = false
              }
            })
          }
        })
      }
    },*/
    submitDetection(){
      this.$refs.batchForm.validate(async(vaild)=>{
        if (vaild){
          if(this.batchInfo.detection_method===9&&!this.checkedList.length){
            this.$message.warning('请选择要检测的数据')
            return false
          }
        /*  if (this.powerNumTotal > this.userInfo.power_num) {
            this.$message.error('当前剩余算力不足，请充值')
            return false
          }*/
          let params = {
            ...this.batchInfo,
            ...this.imgInclude
          }
          if(this.batchInfo.detection_method===9){
            params.ids=this.checkedList.join(',')
          }
          let res =null
          if(this.batchType==='batch'){
            res = await this.handleBatchCheck(params)
          }else{
            res = await this.handleAiCheck(params)
          }
          this.batchLoading = true
          if (res.code == 200) {
            this.$message.success('操作成功')
            this.batchShow = false
            this.checkedList = []
            this.$refs.listTable.clearSelection();
            this.refresh()
          } else {
            this.$message.error(res.message)
          }
          this.batchLoading = false
        }
      })
    },
    //提交常规检测
    handleBatchCheck(params){
      return new Promise((resolve)=>{
        params.word_depots = params.word_depots.join(',')
        this.opSubmitBatchDetection({
          data:params,
          success:(res)=>{
              resolve(res)
          }
        })
      })
    },
    //提交AI检测
    handleAiCheck(params){
      if(this.batchType=='ai'){
        params.detection_type = 9
      }
      if(this.batchType=='false'){
        params.detection_type = 8
      }
      return new Promise((resolve)=>{
        this.opSubmitAiDetection({
          data:params,
          success:(res)=>{
            resolve(res)
          }
        })
      })
    },
    toRecharge() {
      window.open('/uc_wallet?menuId=116')
    },

    // === 终止任务 ===
    handleStop(row) {
      this.$confirm(`确定要终止【${row.task_no}】的图片检测吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opStopImgDetection({
          data: {id: row.id},
          success: (res) => {
            if (res.code == 200) {
              this.$message.success('终止成功')
              this.getTaskList()
            } else {
              this.$message.error(res.message)
            }
          }
        })
      })
    },
    // === 启动任务 ===
    handleStart(row) {
      this.$confirm(`确定要启动【${row.task_no}】的图片检测吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opStartImgDetection({
          data: {id: row.id},
          success: (res) => {
            if (res.code == 200) {
              this.$message.success('启动成功')
              this.getTaskList()
            } else {
              this.$message.error(res.message)
            }
          }
        })
      })
    },
    // === 暂停任务 ===
    handlePause(row) {
      this.$confirm(`确定要暂停【${row.task_no}】的图片检测吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opPauseImgDetection({
          data: {id: row.id},
          success: (res) => {
            if (res.code == 200) {
              this.$message.success('暂停成功')
              this.getTaskList()
            } else {
              this.$message.error(res.message)
            }
          }
        })
      })
    },

    //=== 查看 ===
    handleView(row) {
      this.$router.push('/uc_alienCheck?task_no=' + row.task_no)
    },
    getGroupNameText(groupId, child_group_ids, flag = 0) {
        if (!groupId && flag === 0) return '全部'
        let ids = []
        if (typeof groupId === 'string') {
            try {
                ids = JSON.parse(groupId)
            } catch (e) {
                ids = groupId.split(',').map(item => item.trim())
            }
        } else {
            ids = Array.isArray(groupId) ? groupId : [groupId]
        }

        // 统一处理 child_group_ids 为数组
        let childIds = []
        if (typeof child_group_ids === 'string') {
            try {
                childIds = JSON.parse(child_group_ids)
            } catch (e) {
                childIds = child_group_ids.split(',').map(item => item.trim())
            }
        } else {
            childIds = Array.isArray(child_group_ids) ? child_group_ids : (child_group_ids ? [child_group_ids] : [])
        }

        return ids.filter(id => id) // 去掉空ID
            .map(id => this.groupList.find(item => item.id === id)) // 用ID匹配数组
            .filter(Boolean) // 过滤找不到的
            .map(item => {
                let name = item.name
                // 判断 item.child_groups 是否有值，并筛选出 id 存在于 child_group_ids 中的子分组
                if (item.child_groups && item.child_groups.length > 0 && childIds.length > 0) {
                    const matchedChildNames = item.child_groups
                        .filter(child => childIds.includes(child.id))
                        .map(child => child.name)
                    // 如果有匹配的子分组，则用括号拼接展示
                    if (matchedChildNames.length > 0) {
                        name += `（${matchedChildNames.join('、')}）`
                    }
                }
                return name
            })
            .join('、')
    },
    formatGroupName(row) {
        let group_id = row?.group_id || '-'
        let group_name = this.groupList.find(i => i.id === group_id)?.name || '-'
        let child_group_id = row?.child_group_id || '-'
        const target = this.groupList.find(i => i.id === group_id)?.child_groups?.find(i => i.id === child_group_id)
        const child_group_name = target?.name || null
        if(child_group_name) {
            group_name += '|'+child_group_name
        }
        return group_name;
    },
    changeGroupIds(val) {
        this.$set(this.searchParamsList, 'child_group_id', '')
        this.child_groupList = this.groupList.filter(i => val.includes(i.id)).map(i => i.child_groups || []).flat()
    },
    changeBatchGroupIds(val) {
        this.$set(this.batchInfo, 'child_group_id', [])
        this.batch_child_groupList = this.groupList.filter(i => val.includes(i.id)).map(i => i.child_groups || []).flat()
    },

  }
}
</script>


<style lang="scss" scoped>
.mini-tag {
  white-space: normal;
  height: auto;
  line-height: 17px;

  & ~ .mini-tag {
    margin-top: 3px;
  }
}

:deep(.el-table--scrollable-y .el-table__body-wrappe::-webkit-scrollbar) {
  //::-webkit-scrollbar{
  width: 8px !important;
  //}
}

.w_135 {
  width: 135px;
}

.w_120 {
  width: 150px;
}

.mt-6 {
  margin-top: 6px;
}

.d-s-c {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}


.txt-c {
  text-align: center;
}

.flex-1 {
  flex: 1;
}

.check-box {
  width: 100%;
  display: flex;

  &-title {
    width: fit-content;
    line-height: 32px;
    font-size: 14px;
  }
}

.tab-box {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}

.turn_page {
  display: flex;
  justify-content: flex-end;
  padding: 28px 34px;
}

.goods-info {
  display: flex;
  font-size: 14px;
  color: #333;
  text-align: left;

  .goods-name {
    font-size: 14px;
    color: #333;
  }
}

.goods-img {
  width: 80px;
  height: 80px;
  display: block;
  margin-right: 10px;
}

.detail-box {
  display: flex;
  flex-direction: column;
  max-height: 60vh;
  font-size: 12px;

  .detail-item {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #eee;
  }

  .box-head {
    .detail-item {
      padding-bottom: 20px;
    }

    .goods-img {
      width: 60px;
      height: 60px;
      border-radius: 8px;
      margin-right: 20px;
    }
  }

  .box-body {
    flex: 1;
    overflow-y: auto;
  }
}

.detection-scope {
  color: #999999;
}
</style>
